import { gridSize, gridSizeMdLg12 } from "@/shared";
import { Button, FormControl, Grid, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { ScrollableDialogProps } from "./Dialogs";


type SmartProps = {
  title: string
  name: string;
  label: string;
  texto: string;
  defaultValue?: string | number | null;
  disabled?: boolean;
  control: any;
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  sizeTextFiled?: 'medium' | 'small';
  rows?: number;
  maxPreviewWords?: number
};

export default function SmartTextArea({
  name,
  label,
  defaultValue,
  disabled = false,
  size = gridSize,
  rows = 1,
  texto,
  control,
  sizeTextFiled = 'medium',
  title,
  maxPreviewWords = 10,
}: SmartProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  //const palabras = texto.trim().split(' ');
  /* const textoResumido = palabras.slice(0, 4).join(' ') + '...';
  const mostrarResumen = palabras.length > 5; */
  const mostrarResumen = texto.length > maxPreviewWords
  const textoResumido = texto.slice(0, maxPreviewWords) + '...';

  return (
    <>
      <Grid item {...size}>
        <FormControl fullWidth variant="outlined">
          <Controller
            control={control}
            name={name}
            defaultValue={defaultValue ?? ''}
            render={({ field }) => (
              <TextField
                {...field}
                label={label}
                value={mostrarResumen ? textoResumido : texto}
                variant="outlined"
                fullWidth
                size={sizeTextFiled}
                multiline
                rows={rows}
                disabled={disabled}
                InputProps={{
                  readOnly: true,
                  endAdornment: mostrarResumen && (
                    <InputAdornment position="end">
                      <Button
                        size="small"
                        onClick={() => setIsOpenModal(true)}
                        variant="text"
                      >
                        Ver todo
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        </FormControl>
      </Grid>
      {isOpenModal && (
        <ScrollableDialogProps
          open={isOpenModal}
          title={title}
          onCloseIcon={() => setIsOpenModal(false)}
          contentNode={
            <Grid container spacing={1}>
              <Grid item {...gridSizeMdLg12}>
                <TextField
                  label={label}
                  value={texto}
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={6}
                  sx={{
                    '& .MuiInputBase-input': {
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                    }
                  }}
                />

              </Grid>

            </Grid>
          }
        />
      )}
    </>

  );
}
